export enum AppLanguage {
    zh_hk = 'zh-HK',
    en_us = 'en-US',
}
